<template>
  <div class="com-box">
    <van-collapse v-model="activeNames">
      <van-collapse-item
        title="秒杀设置"
        name="taskConf1"
        class="collapse-item"
      >
      <div class="field-item border-bottom">
        <div class="field-item-title bold">
          地理位置限制
        </div>
        <!-- <van-switch
          v-model="form.boolAreaLimited"
          size="24px"
          active-color="#FF6B31"
          inactive-color="#f4f4f4"
        /> -->
        <van-radio-group v-model="form.boolAreaLimited" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
       
      </div>
      <div class="tips">开启地理位置后，仅限分享门店所在市区才可进行秒杀</div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("change", newVal);
      },
    },
   
  },
  data() {
    return {
      activeNames: [],
    };
  },
  methods: {
    
  },
};
</script>

<style lang="stylus" scoped>
.com-box
  // margin 15px
  >>> .van-collapse
    // border-radius: 8px 8px 0 0
    overflow hidden
  .collapse-item
    >>> .van-collapse-item__title .van-cell__title
      font-weight 600
    >>> .van-collapse-item__content
      padding 0
      .van-cell__title
        color #909399
	>>> .van-field__body input
		color $mainTextColor

.field-item
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    color #323233
    font-weight 600
		background: pink;
	.tips {
		color: #999;
		font-size: 10px;
		margin-left: 18px;
    padding-bottom: 10px;

	}
  .switch-tips {
    margin-left: 0;
    color: red;
  }
	.list {
		display: flex;
		align-items: center
		>>> .van-cell {
			padding: 2px 16px 10px 16px;
		}
    .list-other {
      >>> .van-cell {
        padding-left: 10px;
        padding-right: 0;
        .van-field__body input {
          border-bottom: 1px solid #909399;
        }
      }
    }
    .list-other1 {
       >>> .van-cell {
        padding-left: 8px;
        .van-field__body input {
          border-bottom: 1px solid #909399;
        }
      }
    }
	}
  .other {
    >>> .van-cell {
      .van-field__body input {
        border-bottom: 1px solid #909399;
      }
    }
  }
	.collapse-title {
		font-size: 14px;
		margin-left: 14px;
		color: #000;
		padding-top: 2px;
	}
  .border-bottom{
    background: #fff;
    border-bottom: 1px solid #f4f4f4;
  }
</style>
